// Import packages
import React from "react";
import {Spin, Icon} from "antd";
import {useLocation} from "react-router-dom";
// Import utils
import {history} from "../../configs/history";

// Import styles
import "../../assets/styles/dataDisplay/buttons.scss";
import {setPageOffset} from "../../redux/actions";

const spinIcon = <Icon type="loading" style={{fontSize: 16, color: "#fff"}} spin/>;

export function LinkButton(props) {
    const {title, className, link, cb, loading, disabled, loadingWithTitle, forwardRef, style, getScrollPosition} = props;
    let location = useLocation();

    function onClick(e) {
        const offset = getScrollPosition?.();
        if (offset) {
            const pageName = location.pathname.split('/')?.[1];
            setPageOffset({
                offset,
                pageName,
            })
        }
        if (link) {
            history.push(link);
        } else {
            if (!loading && cb) {
                cb(e);
            }
        }
    }

    return <button className={`link-button ${className ? className : ''}`}
                   ref={forwardRef}
                   style={style}
                   disabled={disabled || false}
                   onClick={onClick}>
        {loading ?
            <div className={`flex-row ${loadingWithTitle ? 'loadingWithTitle' : ''}`}>
                {loadingWithTitle && title}
                <Spin indicator={spinIcon}/>
            </div> :
            <span className="title">{title}</span>}
    </button>
}
